import Vue from "vue";
import post from "./post";
import user from "./user";
import {orderedList, SocialService} from "@/module_social/models/post";

const getState = () => {
    return {
        activeUserId: null,
        eliteFitUserInfo: JSON.parse(localStorage.getItem("userInfo")),
        isLoggedIn: false,
        errors: null,

        socialService: new SocialService(),
        postCategories: [],
        postReportCategories: [],
        commentReportCategories: [],
        userReportCategories: [],

        // posts: {postId: post}
        allPosts: {},
        // all posts comments: {commentId: comments}
        allComments: {},
        // all users profile: {userId: userProfile}
        allUsersProfile: {},

        // order: [userId]
        topProfiles: [],
        topPosts: [],
        activeTopPostsIndex: 0,
        userTopPosts: [],
        activeUserTopPostsIndex: 0,
        hashtagTopPosts: [],
        activeHashtagTopPostsIndex: 0,
        // key to index mapping: {key: index}
        topProfilesPosition: {},
        topPostsPosition: {},
        userTopPostsPosition: {},
        hashtagTopPostsPosition: {},

        // order: [userId]
        userFollowing: [],
        blockedByMe: [],
        userBlockedMe: [],
        // key to index mapping: {key: index}
        userFollowingPosition: {},
        blockedByMePosition: {},
        userBlockedMePosition: {},
    };
};

const state = {
    ...getState()
};

const getters = {
    socialUserInfo(state) {
        return state.allUsersProfile[state.activeUserId];
    }
}

const mutations = {
    setActiveFeedPostIndex(state, i) {
        if (i > -1 && i < state.topPosts.length)
            state.activeTopPostsIndex = i;
    },
    setActiveUserPostIndex(state, i) {
        if (i > -1 && i < state.userTopPosts.length)
            state.activeUserTopPostsIndex = i;
    },
    setActiveHashtagPostIndex(state, i) {
        if (i > -1 && i < state.hashtagTopPosts.length)
            state.activeHashtagTopPostsIndex = i;
    },
    updateOffset(state, totalPages) {
        state.totalPages = totalPages;
        if (state.totalPages > state.pageNo) {
            state.offset = state.pageNo = state.offset + 1;
        }
    },

    setIsLoggedIn(state, isTrue) {
        state.isLoggedIn = isTrue;
    },
    setSocialUserInfo(state, userInfo) {
        Vue.set(state.allUsersProfile, userInfo.userId, userInfo);
        state.eliteFitUserInfo = JSON.parse(localStorage.getItem("userInfo"));
        state.activeUserId = userInfo.userId;
    },
    setErrors(state, errors) {
        state.errors = Object.assign({}, state.errors, errors);
        if (Object.keys(state.errors).length === 0) state.errors = null;
    },
    setTopProfiles(state, nextTopProfiles) {
        nextTopProfiles.forEach(profile => {
            Vue.set(state.allUsersProfile, profile.userId, profile);
            orderedList.add(profile.userId, state.topProfiles, state.topProfilesPosition);
        });
    },
    setBlocked(state, {userId, isBlocked}) {
        let user = Object.assign({}, state.allUsersProfile[userId]);
        user.blockedByMe = isBlocked;
        Vue.set(state.allUsersProfile, userId, user)
        if (isBlocked)
            orderedList.add(userId, state.blockedByMe, state.blockedByMePosition);
        else {
            orderedList.delete(userId, state.blockedByMe, state.blockedByMePosition);
        }
    },
    setFollowing(state, {userId, isFollow}) {
        let user = Object.assign({}, state.allUsersProfile[userId]);
        user.followedByMe = isFollow;
        user.followersCount = (user.followersCount || 0) + (isFollow ? +1:-1);
        Vue.set(state.allUsersProfile, userId, user);
        let activeUser = Object.assign({}, state.allUsersProfile[state.activeUserId]);
        activeUser.followingCount = (activeUser.followingCount || 0) + (isFollow ? +1:-1);
        Vue.set(state.allUsersProfile, state.activeUserId, activeUser);
        if (isFollow)
            orderedList.add(userId, state.userFollowing, state.userFollowingPosition);
        else {
            orderedList.delete(userId, state.userFollowing, state.userFollowingPosition);
        }
    },
    setFollowingUsers(state, following) {
        following.forEach(userId => {
            orderedList.add(userId, state.userFollowing, state.userFollowingPosition);
        });
    },
    setBlockedUsers(state, blockedUsers) {
        blockedUsers.forEach(userId => {
            orderedList.add(userId, state.blockedByMe, state.blockedByMePosition);
        });
    },
    setUsersBlockedMe(state, usersBlockedMe) {
        usersBlockedMe.forEach(userId => {
            orderedList.add(userId, state.userBlockedMe, state.userBlockedMePosition);
        });
    },
    setUsers(state, userProfiles) {
        userProfiles.forEach(profile => {
            // don't update active user info here
            if (state.activeUserId === profile.userId) return;
            profile.followedByMe = profile.userId in state.userFollowingPosition;
            profile.blockedByMe = profile.userId in state.blockedByMePosition;
            profile.userBlockedMe = profile.userId in state.userBlockedMePosition;
            Vue.set(state.allUsersProfile, profile.userId, profile);
        });
    },
    addPost(state, post) {
        Vue.set(state.allPosts, post.id, post);
        orderedList.addAt(post.id, 0, state.topPosts, state.topPostsPosition);
    },
    setHomeFeeds(state, nextHomeFeeds) {
        nextHomeFeeds.forEach(post => {
            Vue.set(state.allPosts, post.id, post);
            orderedList.add(post.id, state.topPosts, state.topPostsPosition);
        });
    },
    setUserPosts(state, posts) {
        posts.forEach(post => {
            Vue.set(state.allPosts, post.id, post);
            orderedList.add(post.id, state.userTopPosts, state.userTopPostsPosition);
        });
    },
    resetUserPosts(state) {
        state.userTopPosts = [];
        state.userTopPostsPosition = {};
        state.activeUserTopPostsIndex = 0;
        state.socialService.resetPagination('userPosts');
    },
    setHashtagPosts(state, posts) {
        posts.forEach(post => {
            Vue.set(state.allPosts, post.id, post);
            orderedList.add(post.id, state.hashtagTopPosts, state.hashtagTopPostsPosition);
        });
    },
    resetHashtagPosts(state) {
        state.hashtagTopPosts = [];
        state.hashtagTopPostsPosition = {};
        state.activeHashtagTopPostsIndex = 0;
        state.socialService.resetPagination('hashtagPosts');
    },
    setPostLike(state, postId) {
        let post = Object.assign({}, state.allPosts[postId]);
        if (post && !post.likedByMe) {
            post.likeCount = (post.likeCount || 0) + 1;
            post.likedByMe = true;
            Vue.set(state.allPosts, post.id, post);
        }
    },
    setPostUnlike(state, postId) {
        let post = Object.assign({}, state.allPosts[postId]);
        if (post && post.likedByMe) {
            post.likeCount = (post.likeCount || 0) - 1;
            post.likedByMe = false;
            Vue.set(state.allPosts, post.id, post);
        }
    },
    addPostComments(state, {postId, comments}) {
        let post = Object.assign({}, state.allPosts[postId]);
        comments.forEach(comment => {
            Vue.set(state.allComments, comment.id, comment);
            post.commentIds.push(comment.id);
        });
        post.commentIds = [...new Set(post.commentIds)];
        Vue.set(state.allPosts, postId, post);
    },
    setComment(state, {postId, comment}) {
        let post = Object.assign({}, state.allPosts[postId]);
        Vue.set(state.allComments, comment.id, comment);
        post.commentCount = (post.commentCount || 0) + 1;
        post.commentIds.push(comment.id);
        post.addedCommentIds.push(comment.id);
        post.commentIds = [...new Set(post.commentIds)];
        post.addedCommentIds = [...new Set(post.addedCommentIds)];
        Vue.set(state.allPosts, postId, post);
    },
    updateComment(state, {postId, comment}) {
        Vue.set(state.allComments, comment.id, comment);
        let post = Object.assign({}, state.allPosts[postId]);
        const addedCommentIndex = post.addedCommentIds.findIndex(id => id === comment.id);
        const commentIndex = post.commentIds.findIndex(id => id === comment.id);
        if (addedCommentIndex > -1) {
            const commentIds = post.commentIds;
            const lastIndex = commentIds.length - 1;
            commentIds.splice(commentIndex, 1);
            commentIds.splice(lastIndex, 0, comment.id);
            post.commentIds = [...new Set(commentIds)];
        }
        if (commentIndex > -1) {
            const commentIds = post.addedCommentIds;
            const lastIndex = commentIds.length - 1;
            commentIds.splice(addedCommentIndex, 1);
            commentIds.splice(lastIndex, 0, comment.id);
            post.addedCommentIds = [...new Set(commentIds)];
        }
        Vue.set(state.allPosts, postId, post);
    },
    deleteComment(state, {postId, commentId}) {
        let post = Object.assign({}, state.allPosts[postId]);
        let index = post.commentIds.findIndex(id => id === commentId);
        if (index > -1) {
            post.commentIds.splice(index, 1);
            index = post.addedCommentIds.findIndex(id => id === commentId);
            if (index > -1) post.addedCommentIds.splice(index, 1);
            post.commentCount = post.commentCount - 1;
            Vue.set(state.allPosts, postId, post);
            Vue.delete(state.allComments, commentId);
        }
    },
    addPostCategories(state, categories) {
        let merged = [...state.postCategories, ...categories]
        state.postCategories = [...new Set(merged)];
    },
    setReportCategories(state, categories) {
        state.commentReportCategories = categories.commentReportCategories;
        state.userReportCategories = categories.userReportCategories;
        state.postReportCategories = categories.postReportCategories;
    },
};

const actions = {
    ...post.actions,
    ...user.actions,
    async authenticate({commit, state}) {
        return state.socialService.authenticate()
            .then(userInfo => {
                commit("setIsLoggedIn", !!userInfo);
                commit("setSocialUserInfo", userInfo);
            })
            .catch(error => {
                commit("setIsLoggedIn", false);
                commit("setErrors", {"signupRespError": error.message});
                return Promise.reject(error);
            })
    },
    async nextPosts({commit, state}) {
        return state.socialService.posts()
            .then(({posts, users}) => {
                if (posts.length) commit("setHomeFeeds", posts);
                if (users.length) commit("setUsers", users);
            })
            .catch(error => {
                commit("setErrors", {"postsError": error.message});
                return Promise.reject(error);
            });
    },
    async userMeta({commit, state}) {
        return state.socialService.userMeta()
            .then(({following, blockedByUser, blockedUser}) => {
                commit("setFollowingUsers", following);
                commit("setBlockedUsers", blockedUser);
                commit("setUsersBlockedMe", blockedByUser);
            })
            .catch(error => {
                commit("setErrors", {"userFollowingError": error.message});
                return Promise.reject(error);
            });
    },
    async nextTopProfiles({commit, state}) {
        return state.socialService.topProfiles()
            .then(topProfiles => {
                if (topProfiles.length) commit("setTopProfiles", topProfiles);
            })
            .catch(error => {
                commit("setErrors", {"topProfilesError": error.message});
                return Promise.reject(error);
            });
    },

    async nextPostCategories({commit, state}) {
        return state.socialService.postCategories()
            .then(categories => {
                if (categories.length) commit("addPostCategories", categories);
            })
            .catch(error => {
                commit("setErrors", {"postCategoriesError": error.message});
                return Promise.reject(error);
            });
    },

    async fetchReportCategories({commit, state}) {
        return state.socialService.reportCategories()
            .then(categories => commit("setReportCategories", categories))
            .catch(error => {
                commit("setErrors", {"reportCategoriesError": error.message});
                return Promise.reject(error);
            });
    },

    async uploadMedia({commit, state}, file) {
        return state.socialService.uploadMedia(file)
            .then(url => url)
            .catch(error => {
                commit("setErrors", {"uploadMediaError": error.message});
                return Promise.reject(error);
            });
    }
};


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    modules: {}
}